import i18next from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import Fetch from 'i18next-fetch-backend'
import { startTransition } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { HydratedRouter } from 'react-router/dom'

if (ENV.MODE === 'production' && ENV.SENTRY_DSN?.startsWith('http')) {
	void import('./utils/monitoring.client.tsx').then(({ init }) => init())
}

async function main() {
	await i18next
		.use(initReactI18next)
		.use(Fetch)
		.use(I18nextBrowserLanguageDetector)
		.init({
			defaultNS: 'common',
			ns: ['common'],
			fallbackLng: 'de',
			detection: { order: ['htmlTag'], caches: [] },
			backend: { loadPath: '/api/locales/{{lng}}/{{ns}}' },
			showSupportNotice: false,
			// React escapes rendered text; i18next escaping on top double-escapes.
			interpolation: { escapeValue: false },
		})

	startTransition(() => {
		hydrateRoot(
			document,
			<I18nextProvider i18n={i18next}>
				<HydratedRouter />
			</I18nextProvider>,
		)
	})
}

main().catch((error) => console.error(error))
